import { useCallback, useMemo, useState } from "react";
import { useHistory } from "react-router-dom";
import { useSelector } from "react-redux";
import { PATHS } from "constants/pathConstants";
import {
  selectKitsSelectedToBeOrdered,
  selectTestKitsGLIsCurrentlyOffering
} from "store/reducers/order/OrderInformationSlice";
import { selectUserPersonalInformation } from "store/reducers/user/UserAccountSlice";
import ModalComponent from "components/sharedComponents/ModalComponent";
import MustBeAdultModal from "./MustBeAdultModal";
import PersonalInfoForm from "components/v3/forms/PersonalInfoForm";
import { Box } from "@mui/material";
import PageTitle from "utils/PageTitle";
import StepperComponent from "components/v3/pages/orderKit/OrderKitStepper";
import StepperLayout from "components/v3/pages/orderKit/SideMenuLayout";

const OrderKitMemberInformationPage = ({ handleSubmit }) => {
  const history = useHistory();
  const memberInformation = useSelector(selectUserPersonalInformation);
  const kitsGLCurrentOffers = useSelector(selectTestKitsGLIsCurrentlyOffering);
  const selectedKitsUuids = useSelector(selectKitsSelectedToBeOrdered);
  const selectedKits = useMemo(() => {
    return kitsGLCurrentOffers.filter((offer) =>
      selectedKitsUuids?.includes(offer?.test_uuid)
    );
  }, [kitsGLCurrentOffers, selectedKitsUuids]);
  const numSelectedKits = selectedKits?.length;
  const [loaded, setLoaded] = useState(true);
  const [mustBeAdultModelIsOpen, setMustBeAdultModelIsOpen] = useState(false);
  const [currentStepIndex] = useState(numSelectedKits + 2);
  const onSubmit = useCallback(
    (formFields) => {
      setLoaded(false);
      handleSubmit?.(formFields);
    },
    [handleSubmit, setLoaded]
  );

  PageTitle("Member Information");

  return (
    <>
      <StepperLayout
        loaded={loaded}
        onboardingStepper={
          <StepperComponent
            activeStepIndex={currentStepIndex}
            onBack={() => {
              history.push(PATHS.ORDER_KIT_INFORMED_CONSENT_SURVEY);
            }}
          />
        }
      >
        <Box
          sx={{
            alignItems: {
              xs: "center",
              md: "flex-start"
            },
            boxSizing: "border-box",
            display: "flex",
            flexDirection: "column",
            gap: {
              xs: "30px",
              md: 8
            },
            marginTop: 0,
            paddingTop: {
              xs: "30px",
              md: 0
            },
            paddingX: {
              xs: "20px",
              md: 0
            }
          }}
        >
          <PersonalInfoForm
            onSubmitted={onSubmit}
            memberData={memberInformation}
          />
        </Box>
      </StepperLayout>
      <ModalComponent
        handleClose={() => {
          setMustBeAdultModelIsOpen(false);
        }}
        open={mustBeAdultModelIsOpen}
        body={
          <MustBeAdultModal
            handleClose={() => {
              setMustBeAdultModelIsOpen(false);
            }}
          />
        }
      />
    </>
  );
};

export default OrderKitMemberInformationPage;
